import { ModalController } from '@ionic/angular';
import { Component } from '@angular/core';

import { PlatformService } from 'app/core/services/platform.service';
import { ModalsService } from '../modals.service';

@Component({
  standalone: false,
  selector: 'modal-force-update',
  templateUrl: 'modal-force-update.component.html',
  styleUrls: ['modal-force-update.component.scss'],
})
export class ModalForceUpdateComponent {
  constructor(
    private modal: ModalController,
    private modalService: ModalsService,
    private platformService: PlatformService,
  ) {}

  onUpdateBtnClick() {
    if (!this.platformService.isCordova()) {
      this.modal.dismiss();
      return;
    }

    this.modalService.openUpdateLink();
  }
}
